import type { FC } from "react";

import type { ILegendItem } from "app/components/React/Legends/legendsTypes";

import LobGroupTrafficShare from "../../shared/LobGroupTrafficShare/LobGroupTrafficShare";
import { BaseBarList } from "../components/shared/BaseBarList";
import { SharedLabelRow } from "../components/shared/SharedLabelRow";
import { BarWrapper } from "../components/shared/styledComponents";
import type { TrafficShareItem } from "../types";

interface IHorizontalBarListProps {
    data: TrafficShareItem[];
    legendItems: ILegendItem[];
}
const TrafficShareItemComponent: FC<{ item: TrafficShareItem }> = ({ item }) => {
    const { label, value, trafficShare, yoyChange, totalVisits, domainYoYChanges } = item;

    return (
        <BarWrapper>
            <div style={{ marginLeft: "1%" }}>
                <SharedLabelRow
                    label={label}
                    value={value}
                    yoyChange={yoyChange}
                />
            </div>
            <LobGroupTrafficShare
                trafficShare={trafficShare}
                totalVisits={totalVisits}
                domainYoYChanges={domainYoYChanges}
                visibleDomains={new Set(Object.keys(trafficShare))}
            />
        </BarWrapper>
    );
};

const TrafficShareBarList: FC<IHorizontalBarListProps> = ({ data, legendItems }) => {
    const renderBarItem = (item: TrafficShareItem) => <TrafficShareItemComponent item={item} />;
    return (
        <BaseBarList
            data={data}
            legendItems={legendItems}
            renderBarItem={renderBarItem}
            showTotal={false}
        />
    );
};

export default TrafficShareBarList;
